export const errorMessages = {
	DEFAULT_ERROR: 'An error has occurred',
	HTTP_STATUS_403: 'Access Forbidden!',
	HTTP_STATUS_404: 'Not Found',
	HTTP_STATUS_5xx: 'Ooops! An error Occurred!',
	SIGN_IN_INVALID_CREDENTIALS: 'Invalid username/email or password',
	ALREADY_REGISTERED: 'User with such e-mail already exists',
	INVALID_INVITATION_CODE: ['Sorry, your invitation link is not valid.', 'Please, contact the Administrator of your Organization'],
	INVITATION_EXPIRED: ['Sorry, your invitation link has expired.', 'Please, contact the Administrator of your Organization'],
	INACTIVE_USER: ['User is inactive.', 'Please, contact the Administrator of your Organization'],
	USER_NOT_ACTIVATED: ['User account is not activated yet.', 'Please check your email inbox and complete registration'],
	PASSWORD_EXPIRED: ['The password has expired.', 'Please change your password.'],
	CHANGE_PASSWORD_INVALID_CREDENTIALS: ['Old Password is not correct.', 'Please, check and try again'],
	DUPLICATED_ORGANIZATION_NAME: ['There is an organization with the same name.', 'Please, choose another name'],
}

export default class ErrorMessageResolver {
	static resolveByCode(code, defaultMessage = errorMessages.DEFAULT_ERROR) {
		return errorMessages[code] || defaultMessage;
	}

	static resolve(error, defaultMessage = errorMessages.DEFAULT_ERROR) {
		const errorResp = error?.response;
		const handledError = {
			originalError: error,
			resolvedErrorMessage: defaultMessage,
			errorDetails: '',
			errorCode: '',
		};

		if (!errorResp || !errorResp.status) {
			return handledError;
		}

		const data = errorResp.data || {};

		handledError.errorCode = (data || {}).errorCode || (data || {}).code || '';

		switch (errorResp.status) {
			case 403:
				handledError.resolvedErrorMessage =
					this.resolveByCode(handledError.errorCode, errorMessages.HTTP_STATUS_403);
				handledError.errorDetails = data.message || 'Access to Portal is denied due to lack of permissions.'
					+ 'Please reach administrator for more details.';
				break;
			case 404:
				handledError.resolvedErrorMessage = errorMessages.HTTP_STATUS_404;
				handledError.errorDetails = data.message || 'Not Found: requested entity not found';
				break;
			case 500:
			case 503:
				handledError.resolvedErrorMessage = errorMessages.HTTP_STATUS_5xx;
				handledError.errorDetails = data.message || 'Sorry! Something went Wrong. The server '
					+ 'encountered an internal error. Please try again a little later, or reach administrator for more details.';
				break;
			default:
				handledError.resolvedErrorMessage = this.resolveByCode(handledError.errorCode, data.message);
				handledError.errorDetails = data.details || data.errorDetails || '';
				break;
		}

		return handledError;
	}
}
